module.exports = __webpack_public_path__ + "img/icn_highlight_slide.ea937de1.svg";